// de strings for messages/nav.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const nav: Dict = {
  "nav.home": "Start",
  "nav.create": "Erstellen",
  "nav.voices": "Stimmen",
  "nav.train": "Stimme trainieren",
  "nav.library": "Bibliothek",
  "nav.tab.profile": "Profil",
  "nav.pricing": "Preise",
  "nav.affiliate": "Partnerprogramm",
  "nav.api": "API",
  "nav.login": "Anmelden",
  "nav.signup": "Registrieren",
  "nav.signupFree": "Kostenlos registrieren",
  "nav.getPlan": "Plan wählen",
  "nav.discordAria": "Dem Jammable-Discord beitreten",
  "nav.discordJoin": "Tritt unserem Discord bei",
  "nav.openMenu": "Menü öffnen",
  "nav.closeMenu": "Menü schließen",

  "nav.greet.0.0": "Hey, Frühaufsteher",
  "nav.greet.0.1": "Moin",
  "nav.greet.0.2": "Na?",
  "nav.greet.0.3": "Hey du",
  "nav.greet.0.4": "Was geht?",
  "nav.greet.1.0": "Yo",
  "nav.greet.1.1": "Hey",
  "nav.greet.1.2": "Hallo",
  "nav.greet.1.3": "Alles klar?",
  "nav.greet.1.4": "Servus",
  "nav.greet.2.0": "Guten Abend",
  "nav.greet.2.1": "Hey du",
  "nav.greet.2.2": "Was läuft?",
  "nav.greet.2.3": "Hi",
  "nav.greet.2.4": "Hallöchen",
  "nav.greet.3.0": "Noch wach?",
  "nav.greet.3.1": "Nachteule, was?",
  "nav.greet.3.2": "Yo, Nachtmensch",
  "nav.greet.3.3": "Kannst nicht schlafen?",
  "nav.greet.3.4": "Late-Night-Vibes",
  "nav.profile.view": "Profil ansehen",
  "nav.profile.credit": "Credit",
  "nav.profile.credits": "Credits",
  "nav.profile.voicePass": "Voice Pass",
  "nav.profile.voices": "Stimmen",
  "nav.profile.shop": "Shop",
  "nav.profile.feedback": "Feedback geben",
  "nav.profile.settings": "Einstellungen",
  "nav.profile.apiDashboard": "API-Dashboard",
  "nav.profile.signOut": "Abmelden",
  "nav.profile.signedOut": "Abgemeldet!",
  "nav.profile.avatarAlt": "Profilbild",

  "nav.footer.tagline":
    "KI-Cover mit über 100.000 Stimmen. In Sekunden erstellt.",
  "nav.footer.colCreate": "Erstellen",
  "nav.footer.colAccount": "Konto",
  "nav.footer.colLegal": "Rechtliches",
  "nav.footer.aiCover": "KI-Cover-Generator",
  "nav.footer.voiceChanger": "KI-Stimmenverzerrer",
  "nav.footer.voiceLibrary": "KI-Stimmen-Bibliothek",
  "nav.footer.train": "Stimme trainieren",
  "nav.footer.weights": "Weights.gg-Alternative",
  "nav.footer.settings": "Einstellungen",
  "nav.footer.earn": "Mit Jammable verdienen",
  "nav.footer.mcp": "MCP-Server für KI-Agenten",
  "nav.footer.forgot": "Passwort vergessen",
  "nav.footer.terms": "Nutzungsbedingungen",
  "nav.footer.privacy": "Datenschutzerklärung",
  "nav.footer.dmca": "DMCA-Richtlinie",
  "nav.footer.refunds": "Erstattungsrichtlinie",
  "nav.footer.pitchmeldBefore": "Nutzt",
  "nav.footer.pitchmeldLink": "Pitchmeld-Technologie",
  "nav.footer.pitchmeldAfter": "für die Sprachverarbeitung",

  "nav.language": "Sprache",
};

export default nav;
